export const aboutData = {
  title: "Who I am",
  description1: `I'm a Full Stack Web Developer with hands-on experience in designing, developing, and maintaining projects. Adept at learning, unlearning, and relearning. Demonstrate the capability of managing clean, elegant, and efficient code. Highly skilled in collaboration, decision-making, and Data Structures & Algorithms.I'm still enthusiastically grabbing on to multiple programming languages, frameworks, and principles that I can add to my skillset. `,
  description2: "",
  image: 2,
};
